<template>
  <v-dialog v-model="dialog.show" max-width="600" persistent>
    <v-card>
      <v-toolbar :color="getAppBarColor" dark>{{ dialog.title }}</v-toolbar>
      <v-card-text>
        <v-form ref="form">
          <v-row align="center">
            <v-col cols="4">
              <v-text-field
                v-model="lead.maxDiasContato"
                label="Dias Maximos para Contato"
                :rules="[rules.required, rules.isNumber]"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="lead.maxDiasExibir"
                label="Dias Maximos para Exibir"
                :rules="[rules.required, rules.isNumber]"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="lead.minDiasExibir"
                label="Dias Mínimos para Exibir"
                :rules="[rules.required, rules.isNumber]"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <SelectTemperatura
                :multiple="false"
                :selected="lead.tempInicialLead"
                @onChanged="lead.tempInicialLead = $event"
              />
            </v-col>
            <v-col cols="4">
              <v-checkbox v-model="lead.validarCelular" label="Validar Celular"></v-checkbox>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          class="ma-3 pl-5 pr-5"
          outlined
          color="blue darken-1"
          small
          dark
          rounded
          depressed
          @click="save()"
        >Salvar</v-btn>

        <v-btn
          class="ma-3 pl-5 pr-5"
          outlined
          color="red darken-2"
          small
          dark
          rounded
          depressed
          @click="close()"
        >Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import rules from "@/utils/rules";
import Parametro from "@/services/parametro";

export default {
  name: "DialogFormLeads",

  components: {
    SelectTemperatura: () => import("@/components/select/SelectTemperatura")
  },

  data() {
    return {
      dialog: {
        show: false,
        title: ""
      },
      lead: {
        empresa: "",
        id: "",
        maxDiasContato: "",
        maxDiasExibir: "",
        minDiasExibir: "",
        tempInicialLead: "",
        validarCelular: ""
      },
      serviceParametro: new Parametro(),
      rules
    };
  },

  methods: {
    async save() {
      try {
        if (this.$refs.form.validate()) {
          this.formatValueToFloat();
          const response = await this.serviceParametro.updateParametro({
            ...this.lead
          });
          this.$emit('updated', {...this.lead})
          this.close();
        }
        return Promise.resolve();
      } catch (error) {
        this.$toast.error("Erro ao editar parametro Lead");
        return Promise.reject(error);
      }
    },

    close() {
      this.$refs.form.resetValidation();
      this.$refs.form.reset();
      this.dialog.show = false;
    },

    formatValueToFloat() {
      this.lead.maxDiasContato = parseFloat(this.lead.maxDiasContato);
      this.lead.maxDiasExibir = parseFloat(this.lead.maxDiasExibir);
      this.lead.minDiasExibir = parseFloat(this.lead.minDiasExibir);
    },

    show(item) {
      this.lead = { ...item };
      this.dialog.title = "Editar Parametro Lead";
      this.dialog.edit = true;
      this.dialog.show = true;
    }
  }
};
</script>
